export default __webpack_public_path__ + "static/media/img_spinner_center_vip.c24c427d.png";